export const HELP = `Usage: alexander.bell-towne.com [command] [options]

An interactive resume website.

Commands:
  cat         print out the contents of a file.
  clear       clear the output screen.
  echo        print out a message.
  home        return to the home screen.
  ls          list the files in the current directory.
  md          render the input as markdown.
  print       send the input to your printer.
  sh          execute a file.

  help        print this message.
`;

export const FILES = [
  'face.png',
  'experience.md',
  'education.md',
  'metadata.md',
  'resume.sh',
];
